<template>
  <popup-container buttonLabel="close">
    <template slot="header">
      {{ title }}
    </template>

    <div class="address">
      <textarea
        ref="address"
        v-model="address"
        class="address-input"
        rows="5">
      </textarea>
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'
import MixinIsSettingsUser from '@/components/Settings/MixinIsSettingsUser'
import _ from 'lodash'

export default {
  mixins: [
    MixinLocale,
    MixinIsSettingsUser
  ],

  components: {
    PopupContainer
  },

  mounted: function () {
    this.$refs.address.focus()
  },

  computed: {
    title: function () {
      if (this.isSettingsUser) {
        return this.$l.userAddressChange
      }
      return this.$l.userAddressInput
    },

    address: {
      get: function () {
        return this.$store.state.user.address
      },
      set: _.debounce(function (value) {
        this.$store.commit('user/setAddress', value)
        if (this.isSettingsUser) {
          this.$store.dispatch('user/saveAddress')
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.address {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 10px;

  &-input {
    @include input-reset-design;
    padding: 8px;
    font-size: 1.2em;
    width: 100%;
  }
}
</style>
